import React, { memo } from 'react';
import PropTypes from 'prop-types';
import SectionNote from '@components/SectionNote';
import MenuSectionImage from '@conversion/components/MenuSectionImage';
import SectionProducts from './SectionProducts';
import Container from './Container';
import Title from './Title';

const WrapSection = ({
  section,
  countryCode,
  hasToValidateAge,
  openAgeValidation,
  onBeforeProductConfig,
  messageValidateTitle,
  messageValidateSubtitle,
}) => (
  <Container>
    <Title>{section.name}</Title>
    <MenuSectionImage image={section.image} country={countryCode} />
    {section.requiresAgeCheck && hasToValidateAge ? (
      <SectionNote
        message={messageValidateTitle}
        actionText={messageValidateSubtitle}
        action={openAgeValidation}
      />
    ) : (
      <SectionProducts
        products={section.products}
        onBeforeProductConfig={onBeforeProductConfig}
      />
    )}
  </Container>
);

WrapSection.propTypes = {
  section: PropTypes.object.isRequired,
  messageValidateTitle: PropTypes.string.isRequired,
  messageValidateSubtitle: PropTypes.string.isRequired,
  onBeforeProductConfig: PropTypes.func.isRequired,
  openAgeValidation: PropTypes.func.isRequired,
  hasToValidateAge: PropTypes.bool.isRequired,
  countryCode: PropTypes.string.isRequired,
};

export default memo(WrapSection);
